var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v(_vm._s(_vm.title))]),(_vm.clientId)?_c('ag-grid-server-side',{attrs:{"id":"lockedAccounts","column-defs":_vm.columnDefs,"server-side-datasource":_vm.serverSideDatasource}}):_c('div',[_vm._v("No client Id set")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }